var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"dapp-detailed-tables-header",class:{
    'dapp-detailed-tables-header--only-one': _vm.existsOnlyOneTable,
    'dapp-detailed-tables-header--disabled': !_vm.isSelected,
  },on:{"click":function($event){return _vm.handleClick()}}},[_vm._t("icon"),_c('span',{staticClass:"font-bold text-lg sm:text-xl md:text-2xl"},[_vm._t("title")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }